let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5A56H"), load("daCag"), load("5kHnW"), load("u2Avf"), load("ac7hE")]).then(() => parcelRequire('2fBti'));